import { lowerFirst } from 'lodash';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { Address } from '~/common/types';

import AddressInput from './AddressInput';
import FieldArrayContainer from '@/shared/components/2.0/formik/FieldArrayContainer';
import useGetEnums from '@/queries/enums/useGetEnums';

type Props = {
  maxHeight?: string;
  className?: string;
};

const AddressesInput: React.FC<Props> = ({ maxHeight = 'max-h-[200px]', className }) => {
  const { t } = useTranslation();

  const {
    enums: { addressFunctions },
  } = useGetEnums();

  const addressFunctionOptions = useMemo(
    () =>
      addressFunctions.map((x: { name: string }) => ({
        label: t(lowerFirst(x.name)),
        value: x.name,
      })),
    [addressFunctions, t],
  );

  return (
    <FieldArrayContainer
      maxHeight={maxHeight}
      className={className}
      title={t('addresses')}
      name="addresses"
      onAdd={({ push }) => push({ addressLine: '', city: '', country: 'BE', postalCode: '' })}
      renderInput={({ form, remove }) =>
        form.values?.addresses?.map((address: Address, index: number) => (
          <AddressInput
            key={index}
            index={index}
            address={address}
            remove={remove}
            addressFunctionOptions={addressFunctionOptions}
          />
        ))
      }
    />
  );
};

export default AddressesInput;
